const getMachineId = () => {
  let machineId = localStorage.getItem('MACHINE_ID');
  if (!machineId) {
    machineId = crypto.randomUUID();
    localStorage.setItem('MACHINE_ID', machineId);
    console.log('new machine id', machineId);
  }
  return machineId;
};

export default getMachineId;
